import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { API } from '@/lib/api';

export default function VisitorCounter() {
    const [count, setCount] = useState(null);

    useEffect(() => {
        const key = 'visited_v1';
        const alreadyCounted = sessionStorage.getItem(key);
        const endpoint = alreadyCounted ? 'GET' : 'POST';
        (async () => {
            try {
                const res = await fetch(`${API}/visits`, { method: endpoint });
                const data = await res.json();
                setCount(data.count);
                if (!alreadyCounted) sessionStorage.setItem(key, '1');
            } catch {
                // silent
            }
        })();
    }, []);

    return (
        <div
            className="w-full bg-ink text-sand-100 border-b border-ink relative z-30"
            data-testid="visitor-counter-bar"
        >
            <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24 py-2 flex items-center justify-center">
                <AnimatePresence mode="popLayout">
                    <motion.span
                        key={count ?? 'x'}
                        initial={{ y: -10, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: 10, opacity: 0 }}
                        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                        className="font-display font-black text-base tabular-nums"
                        data-testid="visitor-count-value"
                    >
                        {count === null ? '···' : count.toLocaleString('ar-EG')}
                    </motion.span>
                </AnimatePresence>
            </div>
        </div>
    );
}
